export default __webpack_public_path__ + "static/media/mg3.7a3f2474.png";